import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Api } from 'src/app/services/api';
import { Globals } from 'src/app/services/globals';
import { canvasSizesByName, posterSizesByName } from '../../../../../../../common/common-types/poster-size';
import { PosterType } from '../../../../../../../common/common-types/poster-type';
import { availableTShirtSizes } from '../../../../../../../common/common-third-party/exakta';

@Component({
    selector: 'size-price-editor',
    templateUrl: './size-price-editor.component.html',
    styleUrls: ['./size-price-editor.component.scss'],
    standalone: false
})
export class SizePriceEditorComponent {
  @Input()
  prices: any;

  @Input()
  type: PosterType;

  @Input()
  sizes: string[];
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, private sanitizer: DomSanitizer) {

  }

  async ngOnInit() {
    if (!this.sizes) {

      if (this.type) {
        switch (this.type) {
          case 'POSTER':
            this.sizes = Object.keys(posterSizesByName);
            break;
          case 'CANVAS':
            this.sizes = Object.keys(canvasSizesByName);
            break;
          case 'TSHIRT':
            this.sizes = availableTShirtSizes;
            break;
        }
      }
      else {
        this.sizes = Object.keys(this.prices)
      }
    }

  }



  ngOnDestroy(): void {


  }

}


